












import Vue from 'vue';
import { Horizontal } from '../../../layout';
import { Icon } from '../../../basic';
import { Button, ButtonGroup, IconButton, InputButton } from '../../buttons';

export default Vue.extend({
  name: 'Pagination',
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  components: {
    Button, ButtonGroup, Horizontal, IconButton, InputButton,
  },
  data() {
    return {
      currentPage: 0,
      currentPageStr: '1',
    };
  },
  watch: {
    currentPageStr() {
      // Handle direct user input
      const previous = this.currentPage;
      this.currentPage = Number(this.currentPageStr) - 1;
      if (isNaN(this.currentPage)) {
        this.currentPage = 0;
      }
      if (this.currentPage >= this.maxPage) {
        this.currentPage = this.maxPage;
      }
      if (this.currentPage < 0) {
        this.currentPage = 0;
      }
      this.currentPageStr = (this.currentPage + 1).toString();
      if (this.currentPage !== previous) {
        this.update();
      }
    },
    currentPage() {
      this.currentPageStr = (this.currentPage + 1).toString();
    },
  },
  computed: {
    maxPage(): number {
      return Math.max(1, Math.ceil(this.totalItems / this.itemsPerPage)) - 1;
    },
    hasPrevious(): boolean {
      return this.currentPage > 0;
    },
    hasNext(): boolean {
      return this.currentPage < this.maxPage;
    },
  },
  methods: {
    previous() {
      if (this.hasPrevious) {
        this.currentPage = this.currentPage - 1;
        this.update();
      }
    },
    next() {
      if (this.hasNext) {
        this.currentPage = this.currentPage + 1;
        this.update();
      }
    },
    first() {
      this.currentPage = 0;
      this.update();
    },
    last() {
      this.currentPage = this.maxPage;
      this.update();
    },
    update() {
      this.$emit('change', {
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
        offset: this.currentPage * this.itemsPerPage,
        limit: this.itemsPerPage,
      });
    },
  },
});
